import { render } from "./operate-system.vue?vue&type=template&id=a3018d18&scoped=true&ts=true"
import script from "./operate-system.vue?vue&type=script&lang=ts"
export * from "./operate-system.vue?vue&type=script&lang=ts"

import "./operate-system.vue?vue&type=style&index=0&id=a3018d18&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3018d18"]])

export default __exports__